import App from './Components/App';
// import theme from './themes/index';
import ReactDOM from "react-dom/client";
import { CssBaseline } from "@mui/material";
// import { ThemeProvider } from '@mui/material/styles';
// import { LayoutProvider } from './context/LayoutContext';
import { Provider } from 'react-redux';
//fonts
import './assets/fonts/ArtegraSansAlt-Black.ttf';
import './assets/fonts/ArtegraSansAlt-Light.ttf';
import './assets/fonts/ArtegraSansAlt-ExtraBold.ttf';
import './assets/fonts/ArtegraSansAlt-Bold.ttf';
import './assets/fonts/ArtegraSansAlt-Medium.ttf';
import './assets/fonts/ArtegraSansAlt-SemiBold.ttf';
import './assets/fonts/ArtegraSansAlt-Regular.ttf';
import './assets/fonts/ArtegraSansAlt-Thin.ttf';

import './index.css'
import { LoadingProvider } from './context/loadingContext';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import config from "../src/Components/config";


// Service Worker Registration
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then((registration) => {
//         console.log('ServiceWorker registration successful with scope: ', registration.scope);

//         // Request background sync
//         if ('SyncManager' in window) {
//           navigator.serviceWorker.ready.then((registration) => {
//             registration.sync.register('locationSync');
//           });
//         }
//       })
//       .catch((error) => {
//         console.error('ServiceWorker registration failed: ', error);
//       });
//   });
// }

if (config.env === 'prod')
  console.log = console.warn = console.error = () => {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <ThemeProvider theme={theme}>
  <>
    <CssBaseline />
    {/* <LayoutProvider> */}
      <LoadingProvider>
        <Provider store={store}>
        <PersistGate  persistor={persistor}>
        <App />
      </PersistGate>
        </Provider>
      </LoadingProvider>
    {/* </LayoutProvider> */}
    </>
  // </ThemeProvider>
);